const {
  PMS_BOOQABLE,
  PMS_CLOUDBEDS,
  PMS_MAESTRO,
  PMS_MEWS,
  PMS_REZSTREAM,
} = require("./constants");

export const pmsThatCanImportBookings = [
  PMS_MEWS,
  PMS_CLOUDBEDS,
  PMS_MAESTRO,
  PMS_BOOQABLE,
];
export const pmsThatCanImportDoors = [
  PMS_MEWS,
  PMS_CLOUDBEDS,
  PMS_MAESTRO,
  PMS_BOOQABLE,
];
export const pmsThatCanImportRoomTypes = [
  PMS_MEWS,
  PMS_CLOUDBEDS,
  PMS_MAESTRO,
  PMS_BOOQABLE,
];
export const pmsThatCanClearPmsUpdated = [
  PMS_REZSTREAM,
  PMS_MEWS,
  PMS_CLOUDBEDS,
  PMS_MAESTRO,
  PMS_BOOQABLE,
];
